import { Button, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { addGame } from '../AdminMenusRequests'
import toast from 'react-hot-toast'

export const AddGames = ({close,setListOfGames,updateScoreBoard}) => {
    const [gameName,setGamename] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = toast.loading('Adding new game'); 
        const res  = await addGame({game_name:gameName});
        if(res.data.status === 200){
            setListOfGames(res.data.data)
            updateScoreBoard();
            close();
            toast.success(res.data.message,{
                id:toastId
            });
        }else{
            toast.error(res.data.message,{
                id:toastId
            });
        }
    }
    return (
        <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField label = 'Game Name' value={gameName} onChange = {(val)=>setGamename(val.target.value)} fullWidth required/>
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>
                    Cancel
                </Button>
                <Button variant='contained' color='success' type='submit'>
                    Save
                </Button>
            </Grid>
        </Grid>
        </form>
    )
}